const EscalaRojoAzul = [
    "#5e4fa2",
    "#3288bd",
    "#66c2a5",
    "#abdda4",
    "#e6f598",
    "#ffffbf",
    "#fee08b",
    "#fdae61",
    "#f46d43",
    "#d53e4f",
    "#9e0142",
];

const EscalaVerdeRojo = [
    "#388e3c",
    "#00c853",
    "#69f0ae",
    "#b9f6ca",
    "#ffcc80",
    "#ffb74d",
    "#ffa726",
    "#ff8a80",
    "#ff5252",
    "#ff1744",
    "#d50000",
];

const EscalaVerdeRojoContrastes = [
    "#ffffff",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
];

const EscalaRojoAzulContraste = [
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#ffffff",
    "#ffffff",
    "#ffffff",
];

const EscalaCelesteGrisContraste = [
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#000000",
];

const EscalaAzules = [
    "#f7fbff",
    "#deebf7",
    "#c6dbef",
    "#9ecae1",
    "#6baed6",
    "#4292c6",
    "#2171b5",
    "#08519c",
    "#08306b",
    "#08306b",
    "#08306b",
];

const EscalaCelesteGris = [
    "#29b6f6",
    "#4fc3f7",
    "#81d4fa",
    "#b3e5fc",
    "#eeeeee",
    "#e0e0e0",
    "#bdbdbd",
    "#9e9e9e",
];

const EscalaAzulesContraste = [
    "#000000",
    "#000000",
    "#000000",
    "#000000",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
];

export {
    EscalaRojoAzul,
    EscalaRojoAzulContraste,
    EscalaAzules,
    EscalaAzulesContraste,
    EscalaVerdeRojo,
    EscalaVerdeRojoContrastes,
    EscalaCelesteGris,
    EscalaCelesteGrisContraste
};
